import { useEmployeeInfo } from "@/api/services/main/employee";
import { Button } from "@/components/elements/Button";
import { DeleteEmployeeModal } from "@/features/employee/components/DeleteEmployeeModal";
import { useVisible } from "@/hooks/useVisible";
import { AppRoutes } from "@/routes/config";
import { EMPLOYMENT_STATUS } from "@/types/enum";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

type TEmployeeFormBtnActionsProps = {
  saveDraft?: () => void;
};

export const EmployeeFormBtnActions: FC<TEmployeeFormBtnActionsProps> = ({ saveDraft }) => {
  const { data: employeeResult } = useEmployeeInfo();

  const deleteModal = useVisible();

  const isCreatePage = location.pathname.startsWith(AppRoutes.employeeCreate);

  const canDelete = employeeResult?.data.employmentStatus === EMPLOYMENT_STATUS.OFFERED || employeeResult?.data?.isDraft;

  return (
    <>
      <Box mt={3}>
        <Stack flexDirection="row" justifyContent="space-between">
          <Stack flexDirection="row" gap={2}>
            {!isCreatePage && (
              <Button variant="danger" disabled={!canDelete} size="sm" onClick={() => deleteModal.open()}>
                削除
              </Button>
            )}
            {(!!employeeResult?.data?.isDraft || isCreatePage) && (
              <Button variant="outline" size="sm" onClick={saveDraft}>
                下書き保存する
              </Button>
            )}
            <Button type="submit" variant="primary" size="sm">
              保存
            </Button>
          </Stack>
        </Stack>
      </Box>

      <DeleteEmployeeModal isOpen={deleteModal.visible} onClose={() => deleteModal.close()} />
    </>
  );
};
